export const GET_DISPLAY_UNIT = 'GET_DISPLAY_UNIT';
export const DISPLAY_UNIT_UPDATED = 'DISPLAY_UNIT_UPDATED';